import React from 'react';
import { Users, MessageSquare, ThumbsUp, Share2 } from 'lucide-react';

const posts = [
  {
    author: 'Edward',
    role: 'Master Farmer',
    content: 'Just implemented the new irrigation system recommended by AVN. Already seeing 20% water savings!',
    likes: 24,
    comments: 8,
    timeAgo: '2h'
  },
  {
    author: 'David K.',
    role: 'Agricultural Expert',
    content: 'Tips for dealing with coffee leaf rust: Early detection and proper fungicide application are key.',
    likes: 45,
    comments: 12,
    timeAgo: '4h'
  },
  {
    author: 'Emma R.',
    role: 'Community Leader',
    content: 'Our community harvest festival is next week! Join us to celebrate sustainable farming.',
    likes: 56,
    comments: 15,
    timeAgo: '6h'
  }
];

const CommunityFeed: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold">Community Feed</h2>
        <Users className="h-5 w-5 text-avn-purple-600" />
      </div>

      <div className="space-y-6">
        {posts.map((post, index) => (
          <div key={index} className="border-b border-gray-100 last:border-0 pb-4 last:pb-0">
            <div className="flex items-start gap-3 mb-2">
              <div className="w-10 h-10 rounded-full bg-avn-purple-100 flex items-center justify-center">
                <span className="text-avn-purple-600 font-medium">
                  {post.author[0]}
                </span>
              </div>
              <div>
                <div className="font-medium">{post.author}</div>
                <div className="text-sm text-gray-500">{post.role}</div>
              </div>
              <div className="text-sm text-gray-500 ml-auto">
                {post.timeAgo} ago
              </div>
            </div>
            <p className="text-gray-600 mb-3">{post.content}</p>
            <div className="flex items-center gap-4 text-sm text-gray-500">
              <button className="flex items-center gap-1 hover:text-avn-purple-600">
                <ThumbsUp className="h-4 w-4" />
                {post.likes}
              </button>
              <button className="flex items-center gap-1 hover:text-avn-purple-600">
                <MessageSquare className="h-4 w-4" />
                {post.comments}
              </button>
              <button className="flex items-center gap-1 hover:text-avn-purple-600">
                <Share2 className="h-4 w-4" />
                Share
              </button>
            </div>
          </div>
        ))}
      </div>

      <button className="w-full mt-6 text-center text-sm text-avn-purple-600 hover:text-avn-purple-700">
        View More Posts
      </button>
    </div>
  );
};

export default CommunityFeed;